/**
 * Form Validation Setup
 * 
 * Centralized Parsley validation configuration and submit handlers.
 * Extracted from utilities.js for better organization.
 */

import $ from 'jquery';

/**
 * Initializes Parsley validation on forms with .data-parsley-validate class
 */
export function initializeFormValidation() {
    if ($('form.data-parsley-validate').length > 0) {
        // Skip validation setup if project location state is present (special case)
        if ($('#project_location_attributes_state_id').length === 0) {
            $('form.data-parsley-validate').parsley({ 'excluded': ':disabled' });
        }
    }

    // Re-enable validation after AJAX success
    $("a[data-remote]").on("ajax:success", function () {
        enableAjaxifyParsley();
    });
}

/**
 * Sets up Parsley validation with loader on valid forms
 * Used for AJAX form submissions
 */
export function enableAjaxifyParsley() {
    if ($('form.data-parsley-validate').length > 0) {
        $('form.data-parsley-validate').parsley({ 'excluded': ':disabled' }).subscribe('parsley:form:validated', function (parsleyForm) {
            if (parsleyForm.validationResult === true) {
                appendLoader();
            }
        });
    }
}

/**
 * Adds loading spinner to submit buttons when form is valid
 */
export function initializeSubmitSpinner() {
    $('body').on('click', 'button[type="submit"], input[type="submit"]', function () {
        const $form = $(this).closest('form.data-parsley-validate');

        if ($form.length > 0 && $form.parsley().isValid() && !$(this).hasClass('nospinner')) {
            $(this).addClass('processing').append('<span class="spinner"/>');
        }
    });
}

/**
 * Helper function to append a loader
 * Assumes appendLoader is defined globally or will be
 */
function appendLoader() {
    if (typeof window.appendLoader === 'function') {
        window.appendLoader();
    }
}
